import styled from "styled-components";

export const StakeLocked = styled.div`

    .warning{  
        width: 24rem;
        font-size: 1.2rem;
        color: ${(props)=> props.theme.palette.common.text.secondary};
    }
`

export const ButtonContainer=styled.div`
    width: 100%;
    margin: 20px auto;
`